import { FeedPostDto } from "@/api/posts/types";
import { NewsFeedPortal } from "../NewsFeedPortal";
import { EndemicImage } from "@/app/(components)/Basic/Image";
export interface Props {
  feedPost: FeedPostDto;
  className?: string;
}

const NewsFeedPostContent = ({ feedPost, className }: Props) => {
  return (
    <div className={className}>
      <NewsFeedPortal feedPost={feedPost} className="mb-4" />
      {!!feedPost.gallery?.length ? (
        <a
          className="relative cursor-pointer h-[400px] w-full block mb-4"
          href={feedPost.portalMetadata?.source}
          target="_blank"
        >
          <EndemicImage
            src={feedPost.gallery[0].imageUrl}
            alt=""
            fill
            className="object-cover"
          />
        </a>
      ) : null}

      <a
        href={feedPost.portalMetadata?.source}
        target="_blank"
        className="block mb-2"
      >
        <span className="text-xl">{feedPost.portalMetadata?.title}</span>
      </a>
      <div className="flex flex-col text-body-3 leading-[22px] mb-2">
        <div className="mb-2">{feedPost.text}</div>
        <a
          href={feedPost.portalMetadata?.source}
          className="text-endemicGray-700 mb-2 endemic:text-secondary text-body-4"
          target="_blank"
        >
          Source: {feedPost.portalMetadata?.portal?.name}
        </a>
      </div>
    </div>
  );
};

export default NewsFeedPostContent;
